import { Component, OnInit,HostListener,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ClienteService } from '../../services/cliente.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

interface DialogData {
  cel: any;
  dpi: any;
  producto: any;
}
@Component({
  selector: 'app-modal-otp',
  templateUrl: './modal-otp.component.html',
  styleUrls: ['./modal-otp.component.scss']
})
export class ModalOtpComponent implements OnInit {
  tokenForm: FormGroup;
  idActive='in1'
  flagNewToken=false
  errorToken=false
  errorMessage=''
  constructor(private fb: FormBuilder,
    private clienteServiceParam: ClienteService,
    private ngxUiLoaderService: NgxUiLoaderService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<ModalOtpComponent>) { 
    this.tokenForm = this.fb.group({
      numero_1: ['', [Validators.maxLength(1), Validators.required]],
      numero_2: ['', [Validators.maxLength(1), Validators.required]],
      numero_3: ['', [Validators.maxLength(1), Validators.required]],
      numero_4: ['', [Validators.maxLength(1), Validators.required]]
    })
    setTimeout(() => {
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
    }, 1500);
  }
@HostListener('keyup', ['$event']) onKeyDown(e: any) {
    if (e.srcElement.maxLength === e.srcElement.value.length) {

      e.preventDefault();

      let nextControl: any = e.srcElement.nextElementSibling;
      // Searching for next similar control to set it focus
      while (true) {
        if (nextControl) {
          if (nextControl.type === e.srcElement.type) {
            nextControl.focus();
            return;
          }
          else {
            nextControl = nextControl.nextElementSibling;
          }
        }
        else {
          return;
        }
      }
    }else if(e.code=='Backspace'&&e.srcElement.value.length==0&& this.idActive==e.srcElement.id){
      e.preventDefault();
      let previousControl: any = e.srcElement.previousElementSibling;
      // Searching for next similar control to set it focus
      while (true) {
        if (previousControl) {
          if (previousControl.type === e.srcElement.type) {
            previousControl.focus();
            return;
          }
          else {
            previousControl = previousControl.previousElementSibling;
          }
        }
        else {
          return;
        }
      }
    }
    this.idActive=e.srcElement.id
  }
  ngOnInit(): void {
  }
  goToDatosGenerales(){
    let tokenuser=this.tokenForm.get('numero_1').value+this.tokenForm.get('numero_2').value+this.tokenForm.get('numero_3').value+this.tokenForm.get('numero_4').value
    this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
    this.clienteServiceParam.validarOTP(tokenuser,this.data.cel,this.data.dpi).then(result=>{
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      this.dialogRef.close({
        result: true 
      }) 
    }).catch(error=>{
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      this.errorMessage='*El token ingresado no es valido, verificación fallida*'
      this.errorToken=true
      setTimeout(() => {
        this.errorToken=false
      }, 6000);
    })
    // if(tokenuser==this.tokenactive){
    //   this.dialogRef.close({
    //     result: true 
    //   }) 
    // }else{
    //   this.dialogRef.close({
    //     result: false
    //   }) 
    // }
  }
  reenviartoken(){
    this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
    this.clienteServiceParam.solicitudOTP(this.data.cel,this.data.dpi,this.data.producto).then(result=>{
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      this.flagNewToken=true
      setTimeout(() => {
        this.flagNewToken=false
      }, 6000);
    }).catch(error=>{
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      this.errorMessage='*ha ocurrido un error en el envio, intente de nuevo*'
      this.errorToken=true
      setTimeout(() => {
        this.errorToken=false
      }, 6000);
    })
  }
}
